import { checkPermission } from '@/utils/permission'

/**
 * Permission directive for Vue 3
 * Hides/removes elements based on user permissions
 * 
 * Usage:
 *   v-permission="'permission:key'"          // Single permission
 *   v-permission="['perm:one', 'perm:two']"  // Multiple permissions (OR logic)
 */
export default {
  mounted(el, binding) {
    const { value } = binding
    
    if (!value) return
    
    const hasPermission = checkPermission(value)
    
    if (!hasPermission) {
      // Remove element from DOM if user doesn't have permission
      el.parentNode?.removeChild(el)
    }
  },
  updated(el, binding) {
    const { value } = binding
    
    if (!value) return
    
    // Handle dynamic permission changes
    const hasPermission = checkPermission(value)
    
    if (!hasPermission && el.parentNode) {
      el.parentNode.removeChild(el)
    }
  }
}
